<span
	*ngIf="hasPrintableAccess && !isR2"
	[ngClass]="[
		'printable-link',
		!sem_btnEnabled ? 'inactive' : '',
		!hasActiveCampaign ? 'inactive' : '',
		version == 'r6' && disableToolTip ? 'primary-color-bg-on-hover100' : '',
		(version == 'r3' || version == 'r3_marketron') && sem_btnEnabled ? 'primary-color-bg' : ''
	]"
>
	<a
		(click)="showWidgetModal()"
		id="{{ version }}-{{ printableProductName }}-slidedeck"
		*ngIf="toolTipMsg && version == 'r1' && version != 'r7'"
		tooltip="{{ toolTipMsg }}"
		tooltip-class="printable-tooltip"
		placement="top"
		class="primary-color"
	>
		<span class="default-printable-heading">Printable Report</span>
		<span class="r102-printable-heading" style="display: none">Generate Report</span>
		<svg
			width="19px"
			height="13px"
			viewBox="0 0 19 13"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			class="default-printable-icon"
			*ngIf="!isR101 && !isR104"
		>
			<g id="Misc" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g id="Download-PR" transform="translate(-217.000000, -61.000000)">
					<g id="Group-2" transform="translate(218.000000, 62.000000)">
						<rect
							id="Rectangle"
							class="primary-svg-stroke"
							fill="#FFFFFF"
							x="-0.5"
							y="-0.5"
							width="15"
							height="10"
							rx="1"
						></rect>
						<g id="Group" transform="translate(3.000000, 2.000000)">
							<rect
								id="Rectangle"
								class="primary-svg-stroke"
								fill="#FFFFFF"
								x="-0.5"
								y="-0.5"
								width="15"
								height="10"
								rx="1"
							></rect>
							<rect id="inside-rectangle" class="primary-svg-fill" x="1" y="1" width="12" height="7"></rect>
						</g>
					</g>
				</g>
			</g>
		</svg>
		<svg
			*ngIf="isR101"
			class="default-printable-icon r101"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.5 3C5.22386 3 5 3.22386 5 3.5C5 3.77614 5.22386 4 5.5 4L10.5 4C11.8807 4 13 5.11929 13 6.5V9.5C13 9.77614 13.2239 10 13.5 10C13.7761 10 14 9.77614 14 9.5V6.5C14 4.567 12.433 3 10.5 3H5.5Z"
				fill="white"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M2 10.5C2 11.3284 2.67157 12 3.5 12H10.5C11.3284 12 12 11.3284 12 10.5V6.5C12 5.67157 11.3284 5 10.5 5L3.5 5C2.67157 5 2 5.67157 2 6.5V10.5ZM3.5 11C3.22386 11 3 10.7761 3 10.5L3 6.5C3 6.22386 3.22386 6 3.5 6L10.5 6C10.7761 6 11 6.22386 11 6.5V10.5C11 10.7761 10.7761 11 10.5 11L3.5 11Z"
				fill="white"
			/>
		</svg>
		<svg
			*ngIf="isR104"
			class="r104-printable-icon"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.5 3C5.22386 3 5 3.22386 5 3.5C5 3.77614 5.22386 4 5.5 4L10.5 4C11.8807 4 13 5.11929 13 6.5V9.5C13 9.77614 13.2239 10 13.5 10C13.7761 10 14 9.77614 14 9.5V6.5C14 4.567 12.433 3 10.5 3H5.5Z"
				fill="white"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M2 10.5C2 11.3284 2.67157 12 3.5 12H10.5C11.3284 12 12 11.3284 12 10.5V6.5C12 5.67157 11.3284 5 10.5 5L3.5 5C2.67157 5 2 5.67157 2 6.5V10.5ZM3.5 11C3.22386 11 3 10.7761 3 10.5L3 6.5C3 6.22386 3.22386 6 3.5 6L10.5 6C10.7761 6 11 6.22386 11 6.5V10.5C11 10.7761 10.7761 11 10.5 11L3.5 11Z"
				fill="white"
			/>
		</svg>
		<svg
			class="r102-printable-icon"
			style="display: none"
			width="21"
			height="17"
			viewBox="0 0 21 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0 1.96875V3.75C0 4.40684 0.521354 4.9375 1.16667 4.9375H1.75H3.5V1.96875C3.5 0.985352 2.71615 0.1875 1.75 0.1875C0.783854 0.1875 0 0.985352 0 1.96875ZM4.08333 0.1875C4.44792 0.684766 4.66667 1.30078 4.66667 1.96875V13.25C4.66667 14.56 5.71302 15.625 7 15.625C8.28698 15.625 9.33333 14.56 9.33333 13.25V13.0533C9.33333 11.851 10.2922 10.875 11.4734 10.875H17.5V3.75C17.5 1.7832 15.9323 0.1875 14 0.1875H4.08333ZM16.9167 16.8125C19.1734 16.8125 21 14.9533 21 12.6562C21 12.3297 20.7375 12.0625 20.4167 12.0625H11.4734C10.9375 12.0625 10.5 12.5041 10.5 13.0533V13.25C10.5 15.2168 8.93229 16.8125 7 16.8125H13.4167H16.9167Z"
				fill="#4A4A4A"
				class="primary-svg-fill"
			/>
		</svg>
	</a>
	<a
		(click)="showWidgetModal()"
		id="{{ version }}-{{ printableProductName }}-slidedeck"
		*ngIf="toolTipMsg && version == 'r8'"
		tooltip="{{ overviewprintablereport == 'overview' ? overviewToolTipMsg : toolTipMsg }}"
		tooltip-class="printable-tooltip"
		placement="top"
		class="primary-color"
	>
		<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M4.1252 1.34375C4.1252 0.791465 4.57291 0.34375 5.1252 0.34375H5.8752C6.42748 0.34375 6.8752 0.791465 6.8752 1.34375V4.15625C6.8752 4.26538 6.85771 4.37043 6.8254 4.46875H7.73059C8.17604 4.46875 8.39912 5.00732 8.08414 5.3223L5.5002 7.90625L2.91625 5.3223C2.60127 5.00732 2.82435 4.46875 3.2698 4.46875H4.17499C4.14268 4.37043 4.1252 4.26538 4.1252 4.15625V1.34375ZM1 7.21875C0.447715 7.21875 0 7.66647 0 8.21875V9.65625C0 10.2085 0.447715 10.6562 1 10.6562H10C10.5523 10.6562 11 10.2085 11 9.65625V8.21875C11 7.66647 10.5523 7.21875 10 7.21875H6.875L5.5 8.59375L4.125 7.21875H1ZM7.5625 8.59375C7.1828 8.59375 6.875 8.90155 6.875 9.28125C6.875 9.66095 7.1828 9.96875 7.5625 9.96875C7.9422 9.96875 8.25 9.66095 8.25 9.28125C8.25 8.90155 7.9422 8.59375 7.5625 8.59375ZM8.9375 8.9375C8.9375 8.74765 9.0914 8.59375 9.28125 8.59375C9.4711 8.59375 9.625 8.74765 9.625 8.9375V9.625C9.625 9.81485 9.4711 9.96875 9.28125 9.96875C9.0914 9.96875 8.9375 9.81485 8.9375 9.625V8.9375Z"
				fill="white"
			/>
		</svg>
		<span class="default-printable-heading">Generate PDF</span>
	</a>
	<a
		*ngIf="version == 'r6' && !disableToolTip"
		id="{{ version }}-{{ printableProductName }}-slidedeck"
		tooltip="{{ toolTipMsg }}"
		tooltip-class="printable-tooltip"
		placement="top"
		(click)="showWidgetModal()"
		class="primary-color"
	>
		<span *ngIf="overviewprintablereport !== 'overview'">Generate PDF</span>
		<span *ngIf="overviewprintablereport == 'overview'">Generate PDF Report</span>
	</a>
	<a
		*ngIf="version == 'r6' && disableToolTip"
		tooltip="{{ overviewprintablereport == 'overview' ? overviewToolTipMsg : '' }}"
		tooltip-class="printable-tooltip"
		placement="top"
		(click)="showWidgetModal()"
		class="primary-color"
		id="{{ version }}-{{ printableProductName }}-slidedeck"
	>
		<span *ngIf="overviewprintablereport !== 'overview'">Generate PDF</span>
		<span *ngIf="overviewprintablereport == 'overview'">Generate PDF Report</span>
	</a>
	<a
		(click)="showWidgetModal()"
		*ngIf="toolTipMsg && hasActiveCampaign && (version == 'r3' || version == 'r3_marketron')"
		id="{{ version }}-{{ printableProductName }}-slidedeck"
		tooltip="{{ toolTipMsg }}"
		tooltip-class="printable-tooltip"
		placement="top"
		style="color: #fff !important"
	>
		<i class="fa fa-download downloadIcon" aria-hidden="true"></i>
		<span>Printable Report</span>
	</a>
	<a
		*ngIf="toolTipMsg && !hasActiveCampaign && (version == 'r3' || version == 'r3_marketron')"
		id="{{ version }}-{{ printableProductName }}-slidedeck"
		tooltip="{{ toolTipMsg }}"
		tooltip-class="printable-tooltip"
		placement="top"
		style="color: #fff !important"
	>
		<i class="fa fa-download downloadIcon" aria-hidden="true"></i>
		<span>Printable Report</span>
	</a>
	<a
		*ngIf="version == 'r13' && directoryName != 'default-r1301'"
		id="{{ version }}-{{ printableProductName }}-slidedeck"
		(click)="showWidgetModal()"
		tooltip="{{ toolTipMsg }}"
		tooltip-class="printable-tooltip"
		placement="top"
	>
		<svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 -2 38 38" class="printable-button">
			<g fill="none" fill-rule="evenodd">
				<path
					[attr.fill]="colorPalette.primaryColor"
					fill-rule="nonzero"
					d="M18 3C9.716 3 3 9.716 3 18c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15zm0 2c7.18 0 13 5.82 13 13s-5.82 13-13 13S5 25.18 5 18 10.82 5 18 5z"
				/>
				<path
					[attr.fill]="colorPalette.primaryColor"
					fill-rule="nonzero"
					d="M22.5 10.5h-12C9.12 10.5 8 11.62 8 13v8c0 1.38 1.12 2.5 2.5 2.5h12c1.38 0 2.5-1.12 2.5-2.5v-8c0-1.38-1.12-2.5-2.5-2.5zm0 1.5c.552 0 1 .448 1 1v8c0 .552-.448 1-1 1h-12c-.552 0-1-.448-1-1v-8c0-.552.448-1 1-1h12z"
				/>
				<rect width="14" height="10" x="9.5" y="12" fill="#FFF" rx="1" />
				<path
					[attr.fill]="colorPalette.primaryColor"
					fill-rule="nonzero"
					d="M25.5 13.5h-12c-1.38 0-2.5 1.12-2.5 2.5v8c0 1.38 1.12 2.5 2.5 2.5h12c1.38 0 2.5-1.12 2.5-2.5v-8c0-1.38-1.12-2.5-2.5-2.5zm0 1.5c.552 0 1 .448 1 1v8c0 .552-.448 1-1 1h-12c-.552 0-1-.448-1-1v-8c0-.552.448-1 1-1h12z"
				/>
				<rect width="14" height="10" x="12.5" y="15" fill="#FFF" rx="1" />
			</g>
		</svg>
	</a>
	<a
		*ngIf="version == 'r13' && directoryName == 'default-r1301' && hasActiveCampaign"
		id="{{ version }}-{{ printableProductName }}-slidedeck"
		(click)="showWidgetModal()"
	>
		<svg
			width="24"
			height="24"
			viewBox="0 0 19 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			class="printable-button"
			tooltip="{{ toolTipMsg }}"
			tooltip-class="printable-tooltip"
			placement="top"
		>
			<path
				d="M18.5169 3.89294L9.83016 0.0699549C9.61986 -0.0233183 9.37948 -0.0233183 9.16807 0.0699549L0.48174 3.89294C0.198199 4.01753 0.0109552 4.29177 0.000440042 4.59829C-0.00970618 4.9042 0.156261 5.19003 0.430455 5.33397L9.11667 9.90557C9.23645 9.96899 9.36774 10 9.49939 10C9.63172 10 9.76283 9.96899 9.8828 9.90557L18.5694 5.33397C18.8434 5.19003 19.0095 4.9042 18.9996 4.59829C18.9877 4.29177 18.8009 4.01753 18.5169 3.89294Z"
				[attr.fill]="colorPalette.primaryColor"
			/>
			<path
				d="M17.8035 7.09222L9.49933 11.3376L1.19656 7.09222C0.799083 6.88896 0.306905 7.03317 0.0962353 7.41339C-0.11591 7.79343 0.0345593 8.26499 0.430933 8.46771L9.11704 12.9084C9.23682 12.9695 9.36811 13 9.49976 13C9.63209 13 9.76319 12.9699 9.88316 12.9084L18.5697 8.46771C18.9651 8.26499 19.1154 7.79343 18.9045 7.41339C18.6922 7.03311 18.1997 6.8889 17.8035 7.09222Z"
				[attr.fill]="colorPalette.primaryColor"
			/>
			<path
				d="M17.8035 10.0923L9.49933 14.3372L1.19656 10.0923C0.799083 9.88885 0.306905 10.0333 0.0962353 10.413C-0.11591 10.7931 0.0345593 11.2653 0.430933 11.4678L9.11704 15.9079C9.23682 15.9695 9.36811 16 9.49976 16C9.63209 16 9.76319 15.9699 9.88316 15.9079L18.5697 11.4678C18.9651 11.2653 19.1154 10.7932 18.9045 10.413C18.6922 10.0333 18.2004 9.88879 17.8035 10.0923Z"
				[attr.fill]="colorPalette.primaryColor"
			/>
		</svg>
	</a>
	<a
		*ngIf="version == 'r13' && directoryName == 'default-r1301' && !hasActiveCampaign"
		id="{{ version }}-{{ printableProductName }}-slidedeck"
	>
		<svg
			width="24"
			height="24"
			viewBox="0 0 19 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			class="printable-button"
			tooltip="{{ toolTipMsg }}"
			tooltip-class="printable-tooltip"
			placement="top"
		>
			<path
				d="M18.5169 3.89294L9.83016 0.0699549C9.61986 -0.0233183 9.37948 -0.0233183 9.16807 0.0699549L0.48174 3.89294C0.198199 4.01753 0.0109552 4.29177 0.000440042 4.59829C-0.00970618 4.9042 0.156261 5.19003 0.430455 5.33397L9.11667 9.90557C9.23645 9.96899 9.36774 10 9.49939 10C9.63172 10 9.76283 9.96899 9.8828 9.90557L18.5694 5.33397C18.8434 5.19003 19.0095 4.9042 18.9996 4.59829C18.9877 4.29177 18.8009 4.01753 18.5169 3.89294Z"
				[attr.fill]="colorPalette.primaryColor"
			/>
			<path
				d="M17.8035 7.09222L9.49933 11.3376L1.19656 7.09222C0.799083 6.88896 0.306905 7.03317 0.0962353 7.41339C-0.11591 7.79343 0.0345593 8.26499 0.430933 8.46771L9.11704 12.9084C9.23682 12.9695 9.36811 13 9.49976 13C9.63209 13 9.76319 12.9699 9.88316 12.9084L18.5697 8.46771C18.9651 8.26499 19.1154 7.79343 18.9045 7.41339C18.6922 7.03311 18.1997 6.8889 17.8035 7.09222Z"
				[attr.fill]="colorPalette.primaryColor"
			/>
			<path
				d="M17.8035 10.0923L9.49933 14.3372L1.19656 10.0923C0.799083 9.88885 0.306905 10.0333 0.0962353 10.413C-0.11591 10.7931 0.0345593 11.2653 0.430933 11.4678L9.11704 15.9079C9.23682 15.9695 9.36811 16 9.49976 16C9.63209 16 9.76319 15.9699 9.88316 15.9079L18.5697 11.4678C18.9651 11.2653 19.1154 10.7932 18.9045 10.413C18.6922 10.0333 18.2004 9.88879 17.8035 10.0923Z"
				[attr.fill]="colorPalette.primaryColor"
			/>
		</svg>
	</a>
	<a
		*ngIf="version == 'r7'"
		id="{{ version }}-{{ printableProductName }}-slidedeck"
		(click)="showWidgetModal()"
		tooltip="{{ toolTipMsg }}"
		tooltip-class="printable-tooltip"
		placement="top"
	>
		<span class="download_text" [ngClass]="{ 'secondary-color': sem_btnEnabled }">Download Printable Report</span>
	</a>
	<a
		*ngIf="version == 'r4'"
		id="{{ version }}-{{ printableProductName }}-slidedeck"
		(click)="showWidgetModal()"
		tooltip="{{ toolTipMsg }}"
		tooltip-class="printable-tooltip"
		placement="top"
	>
		<span
			class="download_text"
			*ngIf="overviewprintablereport !== 'overview'"
			[ngClass]="{ 'primary-color': sem_btnEnabled }"
			>Download Report</span
		>
		<span
			class="download_text"
			*ngIf="overviewprintablereport == 'overview'"
			[ngClass]="{ 'primary-color': sem_btnEnabled }"
			>Download Overview Report</span
		>
	</a>

	<a
		*ngIf="version == 'r11'"
		(click)="showWidgetModal()"
		tooltip="{{ toolTipMsg }}"
		tooltip-class="printable-tooltip"
		placement="top"
	>
		<svg xmlns="http://www.w3.org/2000/svg" width="25" height="17" viewBox="0 0 25 17">
			<g fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<path
									[attr.fill]="colorPalette.primaryColor"
									[attr.stroke]="colorPalette.primaryColor"
									stroke-width="2"
									class="path_1"
									d="M22.718 1L23 15.718 1.282 16 1 1.282 22.718 1z"
									transform="translate(-161 -207) translate(26 197) translate(135.668 8) translate(0 2)"
								/>
								<path
									[attr.fill]="colorPalette.primaryColor"
									stroke="#FFF"
									class="path_2"
									d="M21.426 1.501c.218.004.318.022.415.073.233.286.247.404.247.708h0v12.436c0 .304-.014.422-.074.535-.286.233-.404.247-.708.247h0H2.694c-.304 0-.422-.014-.535-.074-.233-.286-.247-.404-.247-.708h0V2.282c0-.304.014-.422.074-.535.286-.233.404-.247.708-.247h0z"
									transform="translate(-161 -207) translate(26 197) translate(135.668 8) translate(0 2)"
								/>
								<path
									fill="#FFF"
									class="path_3"
									d="M18 6H20V14H18zM14 11H16V14H14zM10 9H12V14H10zM6 12H8V14H6zM7 6c0 1.105-.895 2-2 2s-2-.895-2-2 .895-2 2-2v2z"
									transform="translate(-161 -207) translate(26 197) translate(135.668 8) translate(0 2)"
								/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
		<span class="download_text" [ngClass]="{ 'primary-color': sem_btnEnabled }">Download Report</span>
	</a>

	<a
		*ngIf="version == 'r9'"
		(click)="showWidgetModal()"
		tooltip="{{ toolTipMsg }}"
		tooltip-class="printable-tooltip"
		placement="top"
	>
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
			<path
				d="M3.375 16.25C3.075 16.25 2.8125 16.1375 2.5875 15.9125C2.3625 15.6875 2.25 15.425 2.25 15.125V3.875C2.25 3.575 2.3625 3.3125 2.5875 3.0875C2.8125 2.8625 3.075 2.75 3.375 2.75H14.625C14.925 2.75 15.1875 2.8625 15.4125 3.0875C15.6375 3.3125 15.75 3.575 15.75 3.875V15.125C15.75 15.425 15.6375 15.6875 15.4125 15.9125C15.1875 16.1375 14.925 16.25 14.625 16.25H3.375ZM3.375 15.125H14.625V3.875H3.375V15.125ZM5.8875 13.3063C6.05 13.3063 6.18437 13.2531 6.29062 13.1469C6.39687 13.0406 6.45 12.9063 6.45 12.7438V10.025C6.45 9.8625 6.39687 9.72813 6.29062 9.62188C6.18437 9.51563 6.05 9.4625 5.8875 9.4625C5.725 9.4625 5.59063 9.51563 5.48438 9.62188C5.37812 9.72813 5.325 9.8625 5.325 10.025V12.7438C5.325 12.9063 5.37812 13.0406 5.48438 13.1469C5.59063 13.2531 5.725 13.3063 5.8875 13.3063ZM12.1125 13.3063C12.275 13.3063 12.4094 13.2531 12.5156 13.1469C12.6219 13.0406 12.675 12.9063 12.675 12.7438V5.99375C12.675 5.83125 12.6219 5.69687 12.5156 5.59062C12.4094 5.48438 12.275 5.43125 12.1125 5.43125C11.95 5.43125 11.8156 5.48438 11.7094 5.59062C11.6031 5.69687 11.55 5.83125 11.55 5.99375V12.7438C11.55 12.9063 11.6031 13.0406 11.7094 13.1469C11.8156 13.2531 11.95 13.3063 12.1125 13.3063ZM9 13.3063C9.1625 13.3063 9.29688 13.2531 9.40313 13.1469C9.50938 13.0406 9.5625 12.9063 9.5625 12.7438V11.6562C9.5625 11.4937 9.50938 11.3594 9.40313 11.2531C9.29688 11.1469 9.1625 11.0938 9 11.0938C8.8375 11.0938 8.70312 11.1469 8.59687 11.2531C8.49062 11.3594 8.4375 11.4937 8.4375 11.6562V12.7438C8.4375 12.9063 8.49062 13.0406 8.59687 13.1469C8.70312 13.2531 8.8375 13.3063 9 13.3063ZM9.01875 9.4625C9.16875 9.4625 9.29688 9.40938 9.40313 9.30313C9.50938 9.19688 9.5625 9.0625 9.5625 8.9V8.88125C9.5625 8.73125 9.50625 8.60313 9.39375 8.49688C9.28125 8.39063 9.15 8.3375 9 8.3375C8.8375 8.3375 8.70312 8.39063 8.59687 8.49688C8.49062 8.60313 8.4375 8.7375 8.4375 8.9V8.91875C8.4375 9.06875 8.49375 9.19688 8.60625 9.30313C8.71875 9.40938 8.85625 9.4625 9.01875 9.4625ZM3.375 15.125V3.875V15.125Z"
				fill="#00588E"
			/>
		</svg>
		<span class="download_text" [ngClass]="{ 'primary-color': sem_btnEnabled }">Download Report</span>
	</a>

	<a
		*ngIf="version == 'r10'"
		(click)="showWidgetModal()"
		tooltip="{{ toolTipMsg }}"
		class="product_printable_download_icon product_csv_download_icon"
	>
		<span [ngClass]="{ overview: router.url.includes('overview'), notOverview: !router.url.includes('overview') }">
			<svg xmlns="http://www.w3.org/2000/svg" width="70" height="20" viewBox="0 0 56 20" class="enabled-download-icon">
				<g fill="none" fill-rule="evenodd">
					<rect class="download-button" width="70" height="19" x=".5" y=".5" rx="9.5" />
					<path
						class="arrow-icon-2"
						d="M11.5 4v9.949l3.743-3.742.707.707-4.95 4.95-4.95-4.95.707-.707L10.5 13.95 10.5 4h1z"
					/>
					<text class="arrow-icon" font-family="Assistant-Regular, Assistant" font-size="14">
						<tspan class="with-data" x="22" y="15">Report</tspan>
					</text>
				</g>
			</svg>
		</span>
	</a>
</span>
<span
	*ngIf="isR2 && (hasPrintableAccess || overviewprintablereport == 'overview')"
	[ngClass]="[
		'printable-link',
		!sem_btnEnabled ? 'inactive' : '',
		!hasActiveCampaign ? 'inactive' : '',
		version == 'r6' && disableToolTip ? 'primary-color-bg-on-hover100' : '',
		(version == 'r3' || version == 'r3_marketron') && sem_btnEnabled ? 'primary-color-bg' : ''
	]"
>
	<a
		*ngIf="version == 'r2'"
		id="{{ version }}-{{ printableProductName }}-slidedeck"
		(click)="showWidgetModal()"
		tooltip="{{ toolTipMsg }}"
		tooltip-class="printable-tooltip"
		placement="top"
	>
		<svg
			*ngIf="overviewprintablereport != 'overview' || (overviewprintablereport == 'overview' && overviewReport)"
			width="46px"
			height="46px"
			viewBox="0 0 35 30"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<title>Group</title>
			<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g id="Artboard" transform="translate(-55.000000, -398.000000)">
					<g id="Group" transform="translate(55.000000, 398.000000)">
						<path
							[attr.fill]="colorPalette.primaryColor"
							class="path_one"
							d="M28,0 L28,18 L0,18 L0,0 L28,0 Z M26,2 L2,2 L2,16 L26,16 L26,2 Z"
							fill-rule="nonzero"
						></path>
						<rect
							fill="#FFFFFF"
							id="Rectangle"
							class="path_rectangle"
							fill-rule="nonzero"
							x="2"
							y="2"
							width="24"
							height="14"
						></rect>
						<path
							[attr.fill]="colorPalette.primaryColor"
							class="path_two"
							d="M12,13 L12,15 L10,15 L10,13 L12,13 Z M15,11 L15,15 L13,15 L13,11 L15,11 Z M18,12 L18,15 L16,15 L16,12 L18,12 Z M21,7 L21,15 L19,15 L19,7 L21,7 Z M24,4 L24,15 L22,15 L22,4 L24,4 Z M5.5,3 C6.88071187,3 8,4.11928813 8,5.5 C8,6.88071187 6.88071187,8 5.5,8 C4.11928813,8 3,6.88071187 3,5.5 C3,4.11928813 4.11928813,3 5.5,3 Z"
						></path>
					</g>
				</g>
			</g>
		</svg>
		<span
			*ngIf="overviewprintablereport != 'overview'"
			class="download_text"
			[ngClass]="{ 'primary-color': sem_btnEnabled }"
			>Download Printable Report</span
		>
		<span
			*ngIf="overviewprintablereport == 'overview' && overviewReport"
			class="download_text"
			[ngClass]="{ 'primary-color': sem_btnEnabled }"
			>Download Overview Report</span
		>
	</a>
</span>
<app-modal id="productsModal">
	<div class="modal-background"></div>
	<div class="modal">
		<div class="modal-body">
			<button class="modal-close-button" (click)="closeModal()">
				<svg
					width="23px"
					height="23px"
					viewBox="0 0 23 23"
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					xmlns:xlink="http://www.w3.org/1999/xlink"
				>
					<g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
						<g id="Group-3">
							<circle id="Oval" class="primary-svg-fill" cx="11.5" cy="11.5" r="11.5"></circle>
							<g id="Group-15" transform="translate(3.000000, 2.500000)" fill="#FFFFFF">
								<path
									d="M9,3 C9.55228475,3 10,3.44771525 10,4 L10,7.5 L13.5,7.5 C14.0522847,7.5 14.5,7.94771525 14.5,8.5 L14.5,9.5 C14.5,10.0522847 14.0522847,10.5 13.5,10.5 L10,10.5 L10,14 C10,14.5522847 9.55228475,15 9,15 L8,15 C7.44771525,15 7,14.5522847 7,14 L7,10.499 L3.5,10.5 C2.94771525,10.5 2.5,10.0522847 2.5,9.5 L2.5,8.5 C2.5,7.94771525 2.94771525,7.5 3.5,7.5 L7,7.499 L7,4 C7,3.44771525 7.44771525,3 8,3 L9,3 Z"
									id="Combined-Shape"
									transform="translate(8.500000, 9.000000) rotate(-315.000000) translate(-8.500000, -9.000000) "
								></path>
							</g>
						</g>
					</g>
				</svg>
			</button>
			<div class="modal-heading primary-color">Printable Report Aggregation</div>
			<div class="modal-sub-heading">Select which metrics you want to aggregate across selected campaigns:</div>
			<div class="checkboxContainer primary-color">
				<div *ngFor="let widget of slideWidgetData">
					<label
						[ngClass]="[widget, 'container', printableModalConfig[widget].isDisabled ? 'aggregation-disabled' : '']"
					>
						<input type="checkbox" [(ngModel)]="printableModalConfig[widget].value" value="{{ widget }}" />
						<span class="checkbox-option-text">{{ printableModalConfig[widget].displayName }}</span>
						<span
							[ngClass]="[
								widget,
								'checkmark',
								'primary-color-border',
								printableModalConfig[widget].isDisabled ? 'aggregation-disabled' : '',
								printableModalConfig[widget].value ? 'primary-color-bg' : ' unchecked'
							]"
						></span>
					</label>
				</div>
			</div>
			<div class="modal-button">
				<button class="cancel-button primary-color-bg" (click)="closeModal()">Cancel</button>
				<button class="generate-button primary-color-bg" (click)="navigateToPlatform()">Generate Report</button>
			</div>
		</div>
	</div>
</app-modal>
